export default __webpack_public_path__ + "static/media/NavyaChintaman_headshot.f4badecc.JPG";